import Notification from 'dorothy/utils/alert';
import { put, call, takeLatest, fork } from 'redux-saga/effects';
import { callApi, createReducer, createAction } from 'dorothy/utils';
import * as type from './constant';

function* login(action) {
  const { callback, ...data } = action.payload;
  try {
    const response = yield call(callApi, 'POST', `/api/users/login`, data);
    if (response) {
      yield put(createAction(type.LOGIN_SUCCESS, response.token));
      callback();
    }
  } catch (errorMessage) {
    if (typeof errorMessage === 'string') Notification.error(errorMessage);
    else {
      Notification.error('Username or password is incorrect');
    }
    yield put(createAction(type.REQUEST_ERROR));
  }
}

function* getCurrentUser(action) {
  try {
    const accessToken = sessionStorage.getItem('token');
    if (accessToken) {
      yield put(createAction(type.GET_CURRENT_SUCCESS, accessToken));
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(type.GET_CURRENT_ERROR));
  }
}

function* watchLogin() {
  yield takeLatest(type.LOGIN_REQUEST, login);
}

function* watchGetCurrentUser() {
  yield takeLatest(type.GET_CURRENT_REQUEST, getCurrentUser);
}

const initAuth = { isLoading: false, employees: [], employee: {}, isLogin: false };
const authActionHandlers = {
  [type.LOGIN_REQUEST]: state => ({ ...state, isLoading: true }),
  [type.LOGIN_SUCCESS]: (state, action) => {
    sessionStorage.setItem('token', action.payload);
    return { ...state, isLoading: false, isLogin: true };
  },
  [type.REQUEST_ERROR]: state => ({ ...state, isLoading: false }),
  [type.GET_CURRENT_REQUEST]: state => ({ ...state }),
  [type.GET_CURRENT_SUCCESS]: (state, action) => {
    return { ...state, isLoading: false, isLogin: true };
  },
  [type.GET_CURRENT_ERROR]: state => ({ ...state, isLoading: false }),
};

export const authReducer = createReducer(initAuth, authActionHandlers);
export const authSagas = [fork(watchLogin), fork(watchGetCurrentUser)];
